export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const ALPHABETIC_REGEX =
  /^(?=.*[A-Za-záéíóúÁÉÍÓÚüÜñÑ])[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/;

export const ALPHANUMERIC_REGEX = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ0-9\s]+$/;

export const PHONE_REGEX = /^\+\d{1,4}\(?\d{1,5}\)?\d{4,10}$/;

export const ALPHANUMERIC_SPECIAL_REGEX =
  /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/;

export const NO_CONSECUTIVE_REGEX =
  /^(?!.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{2}).*$/;

export const MIN_LETTERS_REGEX = (minLetters: number) =>
  new RegExp(`(?=(?:.*[A-Za-záéíóúÁÉÍÓÚüÜñÑ]){${minLetters},})`);

export const MIN_NUMBERS_REGEX = (minNumbers: number) =>
  new RegExp(`(?=(?:.*\\d){${minNumbers},})`);
